/* usct-ai-attribution.js — first/last-touch attribution + Google Ads click IDs.
 * Writes cart attributes, which Shopify copies to order.note_attributes at checkout.
 * Adds (2026-08-11): gclid / gbraid / wbraid captured into their own slot so a later
 * non-Google visit cannot overwrite the click ID we need for offline conversion import.
 */
(function () {
  "use strict";
  if (typeof window == "undefined" || !window.localStorage) return;

  var KEY = "usct_attribution_v1",
    TTL_MS = 2160 * 60 * 60 * 1e3, // 90 days
    // Google Ads click-through conversion window is 90 days max, same as TTL above.
    CLICK_PARAMS = ["gclid", "gbraid", "wbraid"],
    AI_SOURCES = {
      "chatgpt.com": "chatgpt",
      "chat.openai.com": "chatgpt",
      "perplexity.ai": "perplexity",
      "www.perplexity.ai": "perplexity",
      "copilot.microsoft.com": "copilot",
      "gemini.google.com": "gemini",
      "bard.google.com": "gemini",
      "claude.ai": "claude",
      "you.com": "you",
      "phind.com": "phind",
      "kagi.com": "kagi"
    };

  function readStore() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      return !data || !data.first_seen_ts || Date.now() - data.first_seen_ts > TTL_MS ? null : data;
    } catch (e) {
      return null;
    }
  }

  function writeStore(d) {
    try {
      localStorage.setItem(KEY, JSON.stringify(d));
    } catch (e) {}
  }

  function parseQs() {
    try {
      var u = new URL(window.location.href),
        p = u.searchParams,
        ref = "";
      try {
        ref = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : "";
      } catch (e) {}
      var utmSource = p.get("utm_source") || "",
        aiSource = "",
        lc = utmSource.toLowerCase();
      if (AI_SOURCES[lc]) aiSource = AI_SOURCES[lc];
      else if (ref && AI_SOURCES[ref]) aiSource = AI_SOURCES[ref];
      else if (p.has("srsltid")) aiSource = "google_surface";

      var clickType = "",
        clickId = "";
      for (var i = 0; i < CLICK_PARAMS.length; i++) {
        var v = p.get(CLICK_PARAMS[i]);
        if (v) {
          clickType = CLICK_PARAMS[i];
          clickId = v;
          break;
        }
      }

      return {
        utm_source: utmSource,
        utm_medium: p.get("utm_medium") || "",
        utm_campaign: p.get("utm_campaign") || "",
        utm_content: p.get("utm_content") || "",
        utm_term: p.get("utm_term") || "",
        srsltid: p.get("srsltid") || "",
        gclid: p.get("gclid") || "",
        fbclid: p.get("fbclid") || "",
        msclkid: p.get("msclkid") || "",
        click_id: clickId,
        click_type: clickType,
        ai_source: aiSource,
        referrer_host: ref,
        landing_page: window.location.pathname,
        ts: Date.now()
      };
    } catch (e) {
      return { ts: Date.now() };
    }
  }

  function hasAttribution(q) {
    return !!(
      q.utm_source ||
      q.click_id ||
      q.gclid ||
      q.fbclid ||
      q.msclkid ||
      q.srsltid ||
      q.ai_source ||
      (q.referrer_host && q.referrer_host !== window.location.hostname)
    );
  }

  var cur = parseQs(),
    stored = readStore(),
    firstTouch,
    lastTouch,
    click;

  if (!stored && hasAttribution(cur)) {
    firstTouch = cur;
    firstTouch.first_seen_ts = Date.now();
    lastTouch = cur;
    click = cur.click_id ? { id: cur.click_id, type: cur.click_type, ts: cur.ts } : null;
    writeStore({ first_seen_ts: firstTouch.first_seen_ts, first_touch: firstTouch, last_touch: lastTouch, click: click });
  } else if (stored) {
    firstTouch = stored.first_touch;
    lastTouch = hasAttribution(cur) ? cur : stored.last_touch || stored.first_touch;
    click = stored.click || null;
    // A newer paid click always wins; a non-Google visit never clears an existing one.
    if (cur.click_id) click = { id: cur.click_id, type: cur.click_type, ts: cur.ts };
    if (hasAttribution(cur)) {
      stored.last_touch = lastTouch;
      stored.click = click;
      writeStore(stored);
    }
  } else {
    return;
  }

  function iso(ts) {
    return ts ? new Date(ts).toISOString() : "";
  }

  function pushToCart() {
    var attrs = {
      attribution_first_source: (firstTouch && firstTouch.utm_source) || (firstTouch && firstTouch.referrer_host) || "direct",
      attribution_first_medium: (firstTouch && firstTouch.utm_medium) || "",
      attribution_first_campaign: (firstTouch && firstTouch.utm_campaign) || "",
      attribution_first_landing: (firstTouch && firstTouch.landing_page) || "",
      attribution_first_ai_source: (firstTouch && firstTouch.ai_source) || "",
      attribution_first_seen: iso(firstTouch && firstTouch.ts),
      attribution_last_source: (lastTouch && lastTouch.utm_source) || (lastTouch && lastTouch.referrer_host) || "direct",
      attribution_last_ai_source: (lastTouch && lastTouch.ai_source) || "",
      attribution_last_landing: (lastTouch && lastTouch.landing_page) || "",
      attribution_last_seen: iso(lastTouch && lastTouch.ts),
      attribution_click_id: (click && click.id) || "",
      attribution_click_type: (click && click.type) || "",
      attribution_click_seen: iso(click && click.ts)
    };
    try {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    } catch (e) {}
  }

  "requestIdleCallback" in window ? requestIdleCallback(pushToCart, { timeout: 3e3 }) : setTimeout(pushToCart, 800);
})();
